import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "card-actions"
}
const _hoisted_4 = {
  key: 0,
  class: "card-fields"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "card-field-value" }
const _hoisted_7 = {
  key: 0,
  class: "pr-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_card_action = _resolveComponent("ontos-card-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_hidden_count = _resolveComponent("ontos-hidden-count")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "kanban-card",
    variant: "flat",
    border: "",
    href: _ctx.href,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ontos_color_accent, {
          row: "",
          color: _ctx.accent,
          class: "card-accent"
        }, null, 8, ["color"]),
        _createElementVNode("span", {
          class: "card-header-title",
          title: _ctx.title
        }, _toDisplayString(_ctx.title), 9, _hoisted_2),
        (_ctx.actions.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.$vuetify.display.smAndDown)
                ? (_openBlock(), _createBlock(_component_v_menu, {
                    key: 0,
                    location: "bottom end"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_ontos_card_action, _mergeProps(props, {
                        icon: "mdi-dots-vertical",
                        title: _ctx.$tt('options')
                      }), null, 16, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        density: "compact",
                        "min-width": "180"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: action.event,
                              "prepend-icon": action.icon,
                              title: action.title,
                              onClick: ($event: any) => (_ctx.$emit(action.event, $event))
                            }, null, 8, ["prepend-icon", "title", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                      return (_openBlock(), _createBlock(_component_ontos_card_action, {
                        key: action.event,
                        icon: action.icon,
                        title: action.title,
                        onAct: ($event: any) => (_ctx.$emit(action.event, $event))
                      }, null, 8, ["icon", "title", "onAct"]))
                    }), 128))
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_ctx.fields.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (property) => {
              return (_openBlock(), _createElementBlock("div", {
                key: property.alias,
                class: _normalizeClass(["card-field", {'card-field--stacked': _ctx.isStacked(property)}])
              }, [
                _createElementVNode("span", {
                  class: "card-field-label",
                  title: property.name
                }, _toDisplayString(property.name), 9, _hoisted_5),
                _createElementVNode("span", _hoisted_6, [
                  (property.alias === _ctx.STATE_KEY && _ctx.stateOption)
                    ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                        key: 0,
                        option: _ctx.stateOption,
                        form: "dot"
                      }, null, 8, ["option"]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.valuesOf(property), (value, valueIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `${property.alias}-${valueIndex}`
                        }, [
                          (valueIndex > 0 && _ctx.needsValueSeparator(property))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " | "))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ontos_property_value, {
                            property: property,
                            value: value,
                            item: _ctx.instance,
                            context: _ctx.context,
                            "choice-domains": _ctx.choiceDomains,
                            variant: "card"
                          }, null, 8, ["property", "value", "item", "context", "choice-domains"])
                        ], 64))
                      }), 128)),
                  _createVNode(_component_ontos_hidden_count, {
                    count: _ctx.hiddenCount(_ctx.instance, property)
                  }, null, 8, ["count"])
                ])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["href"]))
}